import { render, staticRenderFns } from "./ProfileModal.vue?vue&type=template&id=4b477cb6&scoped=true&"
import script from "./ProfileModal.vue?vue&type=script&lang=js&"
export * from "./ProfileModal.vue?vue&type=script&lang=js&"
import style0 from "./ProfileModal.vue?vue&type=style&index=0&id=4b477cb6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b477cb6",
  null
  
)

export default component.exports